import React, { useEffect, useState } from 'react';
import './HighLights.scss';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { Icon, Button } from '../../components/ui/index';
import Pagination from '../../components/pagination/Pagination';
import highlights from '../../constants/highlights.constant';

const HighLights = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(3);

  const indexOfLastHighlight = currentPage * postPerPage;
  const indexOfFirstHighlight = indexOfLastHighlight - postPerPage;
  const currentPost = highlights.slice(indexOfFirstHighlight, indexOfLastHighlight);

  const paginate = pageNumber => setCurrentPage(pageNumber);

  useEffect(() => {
    window.scrollTo({ behavior: 'smooth', top: 0 });
  }, [currentPage]);

  return (
    <>
      <Breadcrumbs path={`Highlights`}></Breadcrumbs>
      <div className="highlights-list">
        {currentPost.map((highlight, index) => (
          <div className={`row${(index + 1) % 2 === 0 ? ' even' : ' odd'}`}>
            <div className="wrapper">
              <div className="column details">
                <h2>
                  <a
                    className="news-title"
                    href="/the-new-face-of-retail-tech-trends-to-watch-for-in-2016"
                  >
                    {highlight.title}
                  </a>
                </h2>

                <span className="author">
                  {`${highlight.author.label} ${highlight.author.link ? 'from ' : ''}`}
                  {highlight.author.link ? (
                    <a href={highlight.author.link.link} target="_blank">
                      {highlight.author.link.label}
                    </a>
                  ) : (
                    ''
                  )}
                </span>
                {highlight.details.map(text => (
                  <p>{text}</p>
                ))}
                {/* http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732 */}
                <Button>View more</Button>

                <ul className="social-list">
                  <li>
                    <a href={highlight.social?.twitter} target="_blank" rel="noreferrer">
                      <Icon imgPath="/images/social-media/twitter-icon-dark.png"></Icon>
                    </a>
                  </li>
                  <li>
                    <a href={highlight.social?.facebook} target="_blank" rel="noreferrer">
                      <Icon imgPath="/images/social-media/facebook-icon-dark.png"></Icon>
                    </a>
                  </li>
                  <li>
                    <a href={highlight.social?.linkedin} target="_blank" rel="noreferrer">
                      <Icon imgPath="/images/social-media/linkedin-icon-dark.png"></Icon>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="image">
                <Icon imgPath={highlight.imgPath}></Icon>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Pagination
        postPerPage={postPerPage}
        totalPost={highlights.length}
        paginate={paginate}
        currentPage={currentPage}
      ></Pagination>
    </>
  );
};

export default HighLights;
